export default __webpack_public_path__ + "static/media/logo.75776b39.png";